export default {
    1: '操作失败, 您没有此权限',
    2: '企业无权限',
    3: '企业无权限',
    504: '请求超时',
    10202: '您已经举报过了，请耐心等待审核!',
    10203: '您要举报的资源已经不存在！',
    900000: '验证失败, 请重试',
    900001: '属性值必填',
    900002: '格式错误',
    900003: '文件大小超出限制',
    900004: '文件类型不支持',
    900005: '该资源已不存在',
    900008: '您好，您的操作过于频繁，请稍后再试',
    900009: '您好，您今日操作过于频繁，请明日再来吧',
    20106: '手机号码已被使用，请重新输入',
    20105: '邮箱已被使用，请重新输入',
    20159: '任务已撤销或已结束，无法催学',
    990001: '上传失败，图片大小不能大于5M',
    910001: '数据类型错误',
    910002: '超过长度限制',
    910003: '必填字段',
    90901: '您的账号已在另一台设备或浏览器登陆，请重新登陆',
    90902: '您的账号已在另一台设备登陆，请重新登陆',
    20138: '一次性验证码过期，可能已经绑定过邮箱，请重新绑定邮箱。',
    30142: '考试越权访问',
    30148: '考试必须通过，才能查看详情',
    21901: '已达到最大添加上限',
    21902: '无权操作该收货地址',
    10134: '短信发送失败',
    20146: '请先添加手机或邮箱',
    20147: '邮箱验证码过期',
    20149: '手机号为空',
    90903: '账户登录频次过多已被限制，请稍后登录',
    20150: '邮箱为空',
    201502: '文件不能为空',
    21903: '文件服务异常,请重试',
    21904: '文件上传异常',
    900901: '企业无权限',
    900902: '未购买此课程',
    900903: '知学荟企业配置为空',
    900904: '回调接口配置为空',
    900905: '回调接口返回结果为空',
    900906: '回调接口返回的信息是失败',
    900907: '未购买此课程',
    900908: '注册接口参数传递有误!',
    900909: '注册接口返回为空!',
    900910: '注册接口调用失败!',
    900911: '该资源已不存在',
    900912: '企业无权限',
    40323: '配置推送内容和学员均为必填项',
};
